import { Outlet } from 'react-router-dom'

import AuthLayoutBase from 'src/shared/features/auth/components/auth-layout-base'
import AuthSideContentVid from 'src/shared/features/auth/components/auth-side-content-vid'
import BaseballVideoFallback from 'src/shared/features/home/assets/baseball-vid.mov'
import BaseballVideoWebm from 'src/shared/features/home/assets/baseball-vid.webm'

export default function ConsumerAuthLayout() {
  return (
    <AuthLayoutBase
      linksVariant="help-and-privacy"
      sideContent={
        <AuthSideContentVid src={BaseballVideoWebm} fallbackSrc={BaseballVideoFallback} title="Where home happens." />
      }
    >
      <Outlet />
    </AuthLayoutBase>
  )
}
